export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13965.6060073e.jpg";